export default function CTA() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 to-emerald-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-gray-900 mb-6">
          Schedule Your IT Service Today
        </h2>
        <p className="text-lg text-gray-700 mb-10 leading-relaxed">
          Easily book your IT service appointment at a time that suits you best. Our team is ready to assist you.
        </p>
        <button 
          onClick={scrollToContact}
          className="bg-teal-500 hover:bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-medium transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
        >
          Schedule a Call
        </button>
      </div>
    </section>
  );
}
